<template>
    <div class="full-height">
        <div class="header-wrapper">
            <div class="header-box">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <header-nav></header-nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="vue-map-container map"></div>
        <div class="main">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-8">
                        <div class="content-box">
                            <div class="form-wrapper form-wrapper_margin">
                                <div class="form-container bg-white pb-5">
                                    <div class="form-container-header">
                                        <h1 class="form-title-title form-title-title_contakt">
                                            {{$t('meta.contacts.h1')}}
                                        </h1>
                                        <h4 class="form-container-subtitle">
                                            {{$t('public.contacts.company.name')}}
                                        </h4>
                                        <div class="form-container-adresses">
                                            <div class="d-flex">
                                                <div class="mr-xl-3 mb-2">
                                                    <span>{{$t('public.contacts.company.address')}}</span>
                                                    <span>
                                                        <a :href="'mailto:' + $t('public.contacts.company.email')">
                                                           {{$t('public.contacts.company.email')}}
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-component></footer-component>
    </div>
</template>

<script>
    export default {
        name: 'Contacts',
        metaInfo() {
            return {
                title: this.$t('meta.contacts.title'),
                meta: [
                    { vmid: 'description', name: 'description', content: this.$t('meta.contacts.description') },
                ]
            }
        },
    }
</script>

<style lang="scss">
    .full-height {
        min-height: 100vh;
        display: flex;
        flex-direction: column;
    }
    .map {
        height: 450px;
    }
    .form-check.form-check-inline {
        padding-bottom: 0;
        @media (max-width: 575.98px) {
            padding-bottom: 13px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Public/Contacts.vue